import { Observation } from "@medplum/fhirtypes";

/**
 * True when an Observation must not be treated as an active flowsheet row (superseded or void).
 * Shared by flowsheet Observation bots and postpartum flowsheet row builders.
 */
export function isFlowsheetObservationSupersededStatus(
  status: Observation["status"] | undefined,
): boolean {
  return status === "cancelled" || status === "entered-in-error" || status === "amended";
}

/**
 * True for void-only statuses (`cancelled`, `entered-in-error`). Use for postpartum flowsheet row
 * visibility and metadata-only QR skip duplicate search — unlike
 * {@link isFlowsheetObservationSupersededStatus}, `amended` stays visible / searchable so a lone
 * amended row still surfaces after metadata-only upsert paths; dedupe then prefers a newer `final`
 * when both share the same QuestionnaireResponse + code.
 */
export function isFlowsheetObservationVoidStatus(
  status: Observation["status"] | undefined,
): boolean {
  return status === "cancelled" || status === "entered-in-error";
}

/**
 * True when an Observation should be omitted from **metadata-only** QR skip duplicate search
 * results. Same predicate as {@link isFlowsheetObservationVoidStatus}.
 */
export function isFlowsheetObservationExcludedFromMetadataOnlySkipSearch(
  status: Observation["status"] | undefined,
): boolean {
  return isFlowsheetObservationVoidStatus(status);
}
